<template>
    <el-col  :span="20">
       <div class="box"></div>
    </el-col>
</template>

<script>
  export default{
    name: 'Home',
    data(){
      return{
        
      }
    },
    methods: {
      
    }
  }
</script>
<style scoped>
    .el-col{
      width: 87%;
      height: 93vh;
      /* padding: 50px; */
      /* margin-top: 20px; */
      background-color: #fff;
      /* margin-right: 40px; */
      /* background-image: url('../assets/busWineDeviceBag.png'); */
      background-size: 100% 100%;
      background-repeat: no-repeat;
      /* border-radius: 10px; */
    }
</style>



// WEBPACK FOOTER //
// src/views/home.vue